import React from 'react'
import { useForm } from 'react-hook-form'
import TextInput from './inputs/text-input'
import SelectInput from './inputs/select-input'
import MultiSelect from './inputs/multi-select'
import TextArea from './inputs/text-area'

export default function MemberInfo({token, league, type, player, member, onComplete}) {
  const memberPosition = () => {
    if (!player.prefer_position) return

    return player.prefer_position.split(', ').map(position => ({ value: position, label: position }))
  }

  const memberDefaults = () => {
    if (player.new) return {}
    
    return {
      skill_level: player.skill_level,
      shirt_size: player.shirt_size,
      self_desc: player.self_desc,
      team_desc: player.team_desc,
      prefer_position: memberPosition()
    }
  }

  const { register, control, handleSubmit, setValue, formState: { errors } } = useForm({
    defaultValues: member || memberDefaults()
  })
  const skillLevelOptions = [['', 'Select'], [0, 'Beginner'], [1, 'Intermediate'], [2, 'Advanced'], [3, 'Expert']]
  const sizeOptions = [['', 'Select'], ['XS', 'XS'], ['S', 'S'], ['M', 'M'], ['L', 'L'], ['XL', 'XL'], ['XXL', 'XXL']]
  const positionOptions = ['Forward', 'Winger', 'Center Midfielder', 'Right / Left Back', 'Center Back', 'Goalie'].map(val => ({value: val, label: val}))
  const requiredMsg = 'Is required'

  const prepareFormData = (data) => {
    let formData = new FormData()
    formData.append('type', type)
    formData.append('token', token)
    formData.append('member[league_id]', league.id)
    formData.append('member[player_id]', player.id)
    formData.append('member[captain]', false)
    formData.append('member[registered]', true)
    if (data.shirt_size) {
      formData.append('player[skill_level]', data.skill_level)
      formData.append('player[prefer_position]', data.prefer_position ? data.prefer_position.map(v => v.label).join(', ') : '')
      formData.append('player[shirt_size]', data.shirt_size)
      formData.append('player[self_desc]', data.self_desc)
      formData.append('player[team_desc]', data.team_desc)
    }
    return formData
  }

  const onSubmit = (data) => {
    const formData = prepareFormData(data)
    onComplete(data, formData)
  }

  return <form className='member-info-form' onSubmit={handleSubmit(onSubmit)}>
    <div className='row'>
      <div className='col-xs-12 text-center greeting-message'>You are going to join this <b>{league.name}</b> league.</div>
    </div>

    { !player.new &&
      [
        <div className='row' key='confirm'>
          <div className='col-xs-12 text-center confirm-message'>Please confirm your information</div>
        </div>,
        <div className='row member-data' key='data'>
          <div className='col-xs-12'>
            <TextInput
              disabled
              label='First Name'
              value={player.first_name}
            />
          </div>
          <div className='col-xs-12'>
            <TextInput
              disabled
              label='Last Name'
              value={player.last_name}
            />
          </div>
          <div className='col-xs-12'>
            <TextInput
              disabled
              label='Email'
              value={player.email}
            />
          </div>
          <div className='col-xs-12'>
            <SelectInput
              {...register('skill_level', { required: requiredMsg })}
              autoFocus
              label='Skill Level'
              options={skillLevelOptions}
              error={errors.skill_level}
              onChange={e => setValue('skill_level', e.target.value)}
            />
          </div>
          <div className='col-xs-12'>
            <MultiSelect
              name='prefer_position'
              label='Preferred Position'
              required
              error={errors.prefer_position}
              options={positionOptions}
              control={control}
            />
          </div>
          <div className='col-xs-12'>
            <SelectInput
              {...register('shirt_size', { required: requiredMsg })}
              label='Shirt Size'
              options={sizeOptions}
              error={errors.shirt_size}
              onChange={e => setValue('shirt_size', e.target.value)}
            />
          </div>
          <div className='col-xs-12'>
            <TextArea
              {...register('self_desc')}
              label='Describe Yourself'
              desc='Describe your experience and attitude toward this league. Captains browsing for players will be able to read this descripion as they search for players.'
              rows='4'
              onChange={(e) => setValue('self_desc', e.target.value)}
            />
          </div>
          <div className='col-xs-12'>
            <TextArea
              {...register('team_desc')}
              label='Describe Your Ideal Team'
              desc="Describe what you're looking for in a team."
              rows='4'
              onChange={(e) => setValue('team_desc', e.target.value)}
            />
          </div>
          <div className='col-xs-12'>
            <button className='registration-button'>Next</button>
          </div>
        </div>
      ]
    }
    
    { player.new && 
      <div className='row'>
        <div className='col-xs-12'>
          <button className='registration-button'>Next</button>
        </div>
      </div>
    }
  </form>
}
